require('./bootstrap');

const Inputmask = require('inputmask');
require('./loading-overlay');

require('./custom-select');
require('./header');
require('./collapsible-list');
require('./off-canvas');
require('./actions');
require('./search');
require('./yt-video');
